import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import chapterImg from "../Assets/Images/Dashboard/chapter_image.png";
import Lottie from "react-lottie";
import loader from "../Assets/Json/loaderJson.json";
import { API_START_POINT } from "../Component/AllApi";
const TeacherVideo = () => {
  const [teacherData, SetTeacherData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [activeGrade, setActiveGrade] = useState("grade_6");
  const [assessmentData, setAssessmentData] = useState({});
  const trainer_id = localStorage.getItem("trainer_id");
  // console.log("trainer_id", trainer_id);
  const selectedSection = localStorage.getItem("selectedSection");

  const TEACHER_VIDEO_TEACHER_LIST =
    selectedSection === "Robotics"
      ? `${API_START_POINT}/getVideosByTrainer/${trainer_id}`
      : `${API_START_POINT}/drone-getVideosByTrainer/${trainer_id}`;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    $(".pageGrades .nav-link").click(function () {
      $(".pageGrades .nav-link").removeClass("active");
      $(this).addClass("active");
    });
  });
  const fetchData = async () => {
    setLoading(true);
    // console.log("fetching data...");
    var token = localStorage.getItem("authToken");
    try {
      const response = await fetch(TEACHER_VIDEO_TEACHER_LIST, {
        method: "GET",
        headers: {
          Authorization: `bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        // console.log(" teacher data: ", data);
        const updatedTeacherData =
          data?.videoAssessment[activeGrade]?.chapters || [];
        SetTeacherData(updatedTeacherData);
        // console.log(updatedTeacherData)

        const assessmentIds = updatedTeacherData.map(
          (chapter) => chapter?.assessment[0]?.assessment_id
        );
        // await fetchAssessmentData(assessmentIds);
        // SetTeacherData(data?.videoAssessment[activeGrade]?.chapters.length === 0?[]:data?.videoAssessment[activeGrade]?.chapters);
        // console.log(" teacher data: ", data);

        // const assessmentIds = data.videoAssessment[activeGrade].chapters.map(
        //   (chapter) => chapter.assessment[0].assessment_id
        // );

        await fetchAssessmentData(assessmentIds);
      }
    } catch (err) {
      console.error("error", err);
    } finally {
      setLoading(false);
      // console.log("fetched data...");
    }
  };
  useEffect(() => {
    fetchData();
  }, [activeGrade]);
  let assessment_ids = [];

  const fetchAssessmentData = async (assessmentIds) => {
    var token = localStorage.getItem("authToken");
    const ASSESSMENT_LIST_API =
      selectedSection === "Robotics"
        ? `${API_START_POINT}/calculate-correct-answers/${assessmentIds}/${trainer_id}`
        : `${API_START_POINT}/drone-calculate-correct-answers/${assessmentIds}/${trainer_id}`;

    try {
      const promises = assessmentIds.map(async (assessmentId) => {
        const response = await fetch(ASSESSMENT_LIST_API, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });

        if (response.ok) {
          return response.json();
        }
        throw new Error("Failed to fetch assessment data");
      });

      const results = await Promise.all(promises);
      // Merge results into a single object
      // console.log("result: ", results);

      const mergedData = results.map((data) => ({
        assessmentId: data?.assessment_id,
        correctAnswers: data?.total_correct_answers,
        totalQuestions: data?.total_questions,
      }));

      setAssessmentData(mergedData);
    } catch (err) {
      console.error("error", err);
    }
  };

  const getAssessmentMarks = (assessmentId) => {
    // console.log("assessment", assessmentData);
    const assessment = assessmentData?.find(
      (data) => data.assessmentId === assessmentId
    );
    return assessment ? (
      `${assessment.correctAnswers}/${assessment.totalQuestions}`
    ) : (
      <div className="status_div_incomplete">
        <p style={{ fontWeight: "500" }}>Not Started</p>
      </div>
    );
  };

  // console.log("teacher data", teacherData);

  return (
    <>
      <section className="mt-5 TeacherProgress">
        <p className="progressMainTitle">Progress</p>
        <div className="pageGrades">
          <ul className="nav" style={{ gap: "20px" }}>
            <li className="nav-item">
              <Link
                className="gradeNavLink active nav-link"
                onClick={() => setActiveGrade("grade_6")}
              >
                VI
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="gradeNavLink nav-link"
                onClick={() => setActiveGrade("grade_7")}
              >
                VII
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="gradeNavLink nav-link"
                onClick={() => setActiveGrade("grade_8")}
              >
                VIII
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="gradeNavLink nav-link"
                onClick={() => setActiveGrade("grade_9")}
              >
                IX
              </Link>
            </li>
            {/* <li className="nav-item">
              <Link
                className="gradeNavLink nav-link"
                onClick={() => setActiveGrade("grade_10")}
              >
                X
              </Link>
            </li> */}
          </ul>
        </div>
        <div className="content mt-5 mb-5">
          {isLoading ? (
            <div>
              <Lottie options={defaultOptions} height={50} width={50} />
            </div>
          ) : (
            <>
              {teacherData?.length < 0 || teacherData?.length === 0 ? (
                <p className="progressMainTitle text-center">
                  No data available
                </p>
              ) : (
                <div
                  className="card"
                  style={{ borderRadius: "24px", border: "none" }}
                >
                  <div className="card-body main">
                    <div className="table-responsive">
                      <table
                        className="table table-borderless align-middle h-100"
                        style={{
                          overflow: "hidden",
                          backgroundColor: "#FFFFFF",
                        }}
                      >
                        <thead className="table_head">
                          <tr>
                            <th style={{ width: "26%" }}>Chapter</th>
                            <th style={{ width: "14%" ,textAlign:"center"}} className="text-center">Topics Completed</th>
                            <th style={{ width: "20%",paddingLeft:'50px' }}>Status</th>
                            <th style={{ width: "20%" }}>Assessment Attempts</th>
                            <th style={{ width: "20%" }}>Assessment Result</th>
                          </tr>
                        </thead>
                        <tbody>
                          {teacherData?.map((data, ind) => {
                            // console.log("map data", data);
                            let completedVideo = 0;
                            data?.videos?.forEach((videoData) => {
                              if (videoData.video.vid_progress === 1) {
                                completedVideo++;
                              }
                            });
                            // console.log("assessment", data.assessment[0].no_of_attempts);
                            return (
                              <tr className="table_body" key={ind}>
                                <td style={{ paddingTop: "0px" }}>
                                  <div className="firstData">
                                    <div className="video_image_div">
                                      <img
                                        src={
                                          data.chapter_thumbnail === "" ||
                                          data.chapter_thumbnail === null
                                            ? chapterImg
                                            : data.chapter_thumbnail
                                        }
                                        onError={(e) => {
                                          e.target.src = chapterImg;
                                        }}
                                        className="video_Image"
                                        alt=""
                                      />
                                    </div>
                                    <div className="content">
                                      <p className="text_top">
                                        Chapter {data.chapter_no}
                                      </p>
                                      <p className="text_inside">
                                        {data.chapter_name}
                                      </p>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <p 
                                  className="marks"
                                  style={{textAlign:"center"}}
                                  // className="marks ms-5 ps-5"
                                  >
                                    {completedVideo}
                                    <span className="inside_marks">
                                      /{data?.videos?.length}
                                    </span>
                                  </p>
                                </td>
                                <td>
                                  {completedVideo === 0 ? (
                                    <div className="status_div_incomplete">
                                      <p style={{ fontWeight: "500" }}>
                                        Not Started
                                      </p>
                                    </div>
                                  ) : completedVideo ===
                                    data?.videos?.length ? (
                                    <div className="status_div_complete">
                                      <p style={{ fontWeight: "500" }}>
                                        Completed
                                      </p>
                                    </div>
                                  ) : (
                                    <div className="status_div_ongoing">
                                      <p style={{ fontWeight: "500" }}>
                                        Ongoing
                                      </p>
                                    </div>
                                  )}
                                </td>
                                <td>
                                  {(data?.assessment[0]?.no_of_attempts || data?.assessment[0]?.no_of_attempts === 0) ? `${data?.assessment[0]?.no_of_attempts}/5` :"0/5" }
                                </td>
                                <td>
                                  <p
                                    className="result"
                                    style={{ fontWeight: "500" }}
                                  >
                                    {completedVideo === 0 ? (
                                      <div className="status_div_incomplete">
                                        <p style={{ fontWeight: "500" }}>
                                          Not Started
                                        </p>
                                      </div>
                                    ) : (
                                      <span className="internal_marks">
                                        {getAssessmentMarks(
                                          data.assessment[0].assessment_id
                                        )}
                                      </span>
                                    )}

                                    {/* {assessmentData.total_correct_answers}/
                                    <span className="internal_marks">
                                      {assessmentData.total_questions}
                                    </span> */}
                                  </p>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default TeacherVideo;
